import React from 'react';

const About: React.FC = () => {
  return (
    <section id="about" className="py-24 bg-white dark:bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-5xl font-bold mb-16 text-gray-900 dark:text-white">
            Building Tomorrow's <br />
            <span className="text-gray-600 dark:text-gray-400">Energy Infrastructure</span>
          </h2>
          
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <p className="text-xl text-gray-700 dark:text-gray-300 leading-relaxed mb-8">
                At Energy Solutions Chile, we are a dedicated group of experts committed to evaluating and developing critical infrastructure solutions, primarily within Chile's dynamic energy sector and the burgeoning High-Performance Computing (HPC) landscape.
              </p>
              <p className="text-xl text-gray-700 dark:text-gray-300 leading-relaxed">
                Our deep understanding of local market regulations and the unique characteristics of the Chilean territory positions us as a strategic partner in advancing the nation's energy transition and digital evolution.
              </p>
            </div>
            
            <div className="space-y-8">
              <div className="border-l-4 border-blue-500 pl-6">
                <h3 className="text-2xl font-semibold mb-3 text-gray-900 dark:text-white">
                  Strategic Market Acumen
                </h3>
                <p className="text-gray-600 dark:text-gray-400">
                  Navigate complex project development cycles with efficiency and precision through our profound knowledge of Chile's market regulations.
                </p>
              </div>
              
              <div className="border-l-4 border-green-500 pl-6">
                <h3 className="text-2xl font-semibold mb-3 text-gray-900 dark:text-white">
                  Comprehensive Capabilities
                </h3>
                <p className="text-gray-600 dark:text-gray-400">
                  Full project lifecycle expertise from conceptualization to operational excellence, including development, design, and approvals.
                </p>
              </div>
              
              <div className="border-l-4 border-orange-500 pl-6">
                <h3 className="text-2xl font-semibold mb-3 text-gray-900 dark:text-white">
                  Technology Integration
                </h3>
                <p className="text-gray-600 dark:text-gray-400">
                  Bridging renewable energy sources, grid optimization, and advanced computing infrastructure for sustainable growth.
                </p>
              </div>
            </div>
          </div>
          
          <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-blue-400 mb-2">15+</div>
              <div className="text-gray-600 dark:text-gray-400">Years Experience</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-green-400 mb-2">500MW</div>
              <div className="text-gray-600 dark:text-gray-400">Projects Developed</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-orange-400 mb-2">100%</div>
              <div className="text-gray-600 dark:text-gray-400">Renewable Focus</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-purple-400 mb-2">24/7</div>
              <div className="text-gray-600 dark:text-gray-400">Grid Reliability</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;